import { Component, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'slotcom-p',
  templateUrl: './p.component.html',
  styleUrls: ['./p.component.scss'],
  standalone: true,
})
export class ParagraphComponent implements AfterViewInit {
  @ViewChild('textParagraph', { static: true }) textElement: ElementRef;
  @Input() text: string = '----';
  @Input() bold: boolean = false;
  @Input() shadow: boolean = false;
  @Input() shadowBorder: boolean = false;
  @Input() fontSize: number;
  @Input() padding: number = 1;
  @Input() marginBottom: number = 0;
  @Input() noPadding: boolean = false;

  gridRatio: number = 0.757;
  element: HTMLElement;

  ngAfterViewInit() {
    this.applyFontSize();
    this.applyMarginBottom();
  }

  private applyFontSize() {
    this.textElement.nativeElement.style.fontSize = this.fontSize * this.gridRatio + 'em';
  }

  private applyMarginBottom() {
    this.textElement.nativeElement.style.marginBottom = this.marginBottom * this.gridRatio + 'em';
  }
}
